import { creativeCommonsNd, circleDotRegular, circleCheckRegular, circleNotchRegular, almost, checkmarkCircle, remove, circleExclamationSolid, circleDotCircleRegular } from '@/plugins/@medirex/icons'

export default {
	data() {
		return {
			statusMap: {
				DRAFT: {
					name: this.$t('Rozpracovaná'),
					color: '#0056B3',
					background: '#F4F6F8',
					icon: creativeCommonsNd,
					total: null
				},
				SENT: {
					name: this.$t('Odoslaná'),
					color: '#015AE9',
					background: '#DBEEFF',
					icon: circleDotRegular,
					total: null
				},
				REGISTERED: {
					name: this.$t('Prijatá'),
					color: '#CD7E35',
					background: '#FAEEE3',
					icon: circleCheckRegular,
					total: null
				},
				IN_PROCESS: {
					name: this.$t('Spracováva sa'),
					color: '#D69A00',
					background: '#FFF5D0',
					icon: circleNotchRegular,
					total: null
				},
				PARTIAL_FINISHED: {
					name: this.$t('Čiastočne spracovaná'),
					color: '#67B94F',
					background: '#F2FAF0',
					icon: almost,
					total: null
				},
				FINISHED: {
					name: this.$t('Spracovaná'),
					color: '#3FA021',
					background: '#E4F5DF',
					icon: checkmarkCircle,
					total: null
				},
				CANCELLED: {
					name: this.$t('Zrušená'),
					color: '#CB2929',
					background: '#FAEAEA',
					icon: remove,
					total: null
				}
			}
		}
	}
}